import React, { useEffect, useState } from "react";
import { Route, useParams } from "react-router-dom";

import "../assets/scss/modal.scss";

import UtilService from "../services/UtilService";

export default function Modal({ title }) {
  const [open, setOpen] = useState(false);
  const [text, setText] = useState();
  const [error, setError] = useState(false);
  //   const handleModal = (value) => {
  //     setOpen(value);
  //   };

const getUrl = () => {
  var url = window.location.href;
  var subModuloId = parseInt(url.charAt(url.length-1));
  if(Number.isInteger(subModuloId)){
    UtilService.getAjuda(subModuloId)
    .then((response) => {
      if (response) {
        setText(response.descricao);
      }
    })
    .catch((error) => {
      setError(error);
    });
  }
}

  useEffect(() => {
    getUrl();
  }, []);

  return (
    <>
      <div className="modal--content">
        <button
          type="button"
          className="global-btn-info"
          onClick={() => setOpen(true)}
          text="a"
        >
          ?
        </button>

        {open === true && (
          <div className="modal-mask">
            <div className="modal-container">
              <div className="modal-side-header">
                <h1>{title}</h1>
                <span onClick={() => setOpen(false)}>X</span>
              </div>

              <div className="modal--content">
                <div
                  className="content"
                  dangerouslySetInnerHTML={{ __html: text }}
                ></div>
              </div>
              {/* <button className="global-btn">DOWNLOAD PDF</button> */}
            </div>
          </div>
        )}
      </div>

      <div
        className={
          open ? "modal-outer-download modal-open" : "modal-outer-download"
        }
        onClick={() => {
          setOpen(false);
        }}
      />
    </>
  );
}
